import React from "react";
import { Stack, Text } from "@bookingcom/bui-react";
import styles from "./ContentWithTitle.module.css";
export default function ContentWithTitle(props) {
    const { title, content } = props;
    const isContent = content !== undefined;
    return (React.createElement(Stack, { className: styles.content_with_title, tagName: "span", gap: 0, direction: "column" },
        React.createElement(Text, { variant: isContent ? "small_1" : "body_2", className: styles.content_with_title__title, tagName: "span" }, title),
        isContent ? React.createElement("span", { className: styles.content_with_title__content }, content) : undefined));
}
